import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getSelfUser, getShops } from "../../services/auth/actions";
import { openMobile } from "../../entrypoints/dashboard/layouts/dashboard/actions";
import { MobileSearchbar, Searchbar, User, Notification, Logo, Authentication } from "./components";
import Status from "../../entrypoints/dashboard/layouts/dashboard/status";
import { useHistory, useLocation } from "react-router";
import {Arrow, Info, SearchIcon} from "../../entrypoints/dashboard/layouts/dashboard/sidebar/icons/icons/icons";
import useMobile from "../../hooks/useMobile";

import "./style.scss";

const Menu = () => (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M4 6H20" stroke="#555D67" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
		<path d="M4 12H20" stroke="#555D67" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
		<path d="M4 18H20" stroke="#555D67" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
	</svg>
)

const Close = () => (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M18 6L6 18" stroke="#555D67" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
		<path d="M6 6L18 18" stroke="#555D67" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
	</svg>
);

export const UserPlaceholder = () => {
	return (
		<div className="user-menu">
			<div className="user-menu-trigger">
				<div className="user-menu-trigger-icon">
					<i className="fas fa-user-circle" style={{fontSize: "2rem"}} />
				</div>
				<div className="user-menu-trigger-info">
					<span className="user-menu-title skeleton skeleton2" style={{borderRadius: ".25rem", width: 50, height: 16}}></span>
					<span className="user-menu-subtitle skeleton skeleton3" style={{borderRadius: ".25rem", width: 40, height: 15}}></span>
				</div>
				<div className="user-menu-trigger-arrow">
					<Arrow />
				</div>
			</div>
		</div>
	)
}

const Garland = () => {


	const [show, setShow] = useState(false);
	const { pathname } = useLocation();

	useEffect(() => {
		let x = Math.floor(Math.random() * (6 - 1 + 1)) + 1;

		if(x === 1 || x === 3 || x === 6) {
			setShow(true);
		} else {
			setShow(false);
		}
	}, [pathname]);

	return <div className={`garland-container ${!show ? 'hide' : ''}`}>
		{[1, 2, 3, 4, 5, 6].map((i) => (
			<div key={i} className="garland">
				<svg className="garland-item" width="64" height="20" fill="none"
					 xmlns="http://www.w3.org/2000/svg">
					<path d="M8 5c21.703 3.116 34.075 4 56 4" stroke="currentColor"/>
					<g opacity=".8" filter="url(#a)">
						<path className="garland-shadow" d="M9.5 14c-1.313 0-2.102-1-2.89-2.75-.745-1.655-1.056-3.784.54-4.75.713-.432 1.044-.5 2.35-.5s1.637.068 2.35.5c1.596.966 1.285 3.095.54 4.75C11.602 13 10.813 14 9.5 14z" fill="currentColor" />
					</g>
					<path className="garland-lamp" d="M9.5 13c-1.313 0-2.102-1-2.89-2.75-.745-1.655-1.056-3.784.54-4.75.713-.432 1.044-.5 2.35-.5s1.637.068 2.35.5c1.596.966 1.285 3.095.54 4.75C11.602 12 10.813 13 9.5 13z" fill="currentColor" />
					<defs>
						<filter id="a" x="0" y="0" width="19" height="20" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
							<feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
							<feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape"></feBlend>
							<feGaussianBlur stdDeviation="3" result="effect1_foregroundBlur_116_127907"></feGaussianBlur>
						</filter>
					</defs>
				</svg>
				<svg className="garland-item" width="67" height="21" fill="none"
					 xmlns="http://www.w3.org/2000/svg">
					<path d="M66 3S31.925 7 10 7" stroke="currentColor"></path>
					<g opacity=".8" filter="url(#fade)">
						<path className="garland-shadow" d="M7.373 13.688c-1.114-.696-1.252-1.961-.993-3.863.245-1.798 1.109-3.768 2.974-3.742.835.011 1.151.13 2.258.821 1.108.692 1.352.925 1.729 1.67.841 1.665-.551 3.305-2.06 4.314-1.596 1.066-2.794 1.497-3.908.8z" fill="currentColor" />
					</g>
					<path className="garland-lamp" d="M7.903 12.84c-1.114-.695-1.252-1.961-.993-3.863.245-1.798 1.109-3.768 2.974-3.742.835.011 1.151.13 2.258.821 1.108.692 1.352.925 1.729 1.67.84 1.665-.551 3.305-2.06 4.314-1.596 1.066-2.794 1.497-3.908.8z" fill="currentColor" />
					<defs>
						<filter id="fade" x="0" y="0" width="19" height="20" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
							<feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
							<feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape"></feBlend>
							<feGaussianBlur stdDeviation="3" result="effect1_foregroundBlur_116_127912"></feGaussianBlur>
						</filter>
					</defs>
				</svg>
				<svg className="garland-item" width="67" height="21" fill="none"
					 xmlns="http://www.w3.org/2000/svg">
					<path d="M10 8s28.088 2.196 56 3.334" stroke="currentColor"></path>
					<g opacity=".8" filter="url(#fade)">
						<path className="garland-shadow" d="M13.466 14.144c-1.006.845-2.252.585-3.981-.249-1.634-.789-3.241-2.22-2.64-3.985.269-.79.479-1.055 1.479-1.894 1-.84 1.297-1 2.122-1.128 1.844-.285 2.973 1.546 3.466 3.292.521 1.847.56 3.12-.446 3.964z" fill="currentColor"></path>
					</g>
					<path className="garland-lamp" d="M12.823 13.378c-1.006.844-2.252.585-3.98-.25C7.207 12.34 5.6 10.91 6.201 9.145c.269-.79.479-1.055 1.48-1.894 1-.84 1.296-1 2.121-1.128 1.844-.285 2.974 1.546 3.466 3.292.522 1.847.56 3.12-.446 3.964z" fill="currentColor"></path>
					<defs>
						<filter id="fade" x=".716" y=".859" width="19.556" height="19.805"
								filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
							<feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
							<feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape"></feBlend>
							<feGaussianBlur stdDeviation="3"
											result="effect1_foregroundBlur_116_127917"></feGaussianBlur>
						</filter>
					</defs>
				</svg>
				<svg className="garland-item" width="66" height="20" fill="none"
					 xmlns="http://www.w3.org/2000/svg">
					<path d="M9 9.334c9.757.398 19.493.666 28 .666 10.49 0 19.512-.09 28-.313"
						  stroke="currentColor"></path>
					<g opacity=".8" filter="url(#fade)">
						<path className="garland-shadow"
							  d="M14.517 7.485c.677 1.126.225 2.316-.869 3.893-1.034 1.491-2.699 2.855-4.35 1.985-.737-.39-.966-.638-1.638-1.758-.673-1.119-.785-1.437-.782-2.272.006-1.866 1.992-2.695 3.794-2.908 1.906-.226 3.169-.066 3.845 1.06z"
							  fill="currentColor"></path>
					</g>
					<path className="garland-lamp"
						  d="M13.66 8c.676 1.126.225 2.316-.869 3.893-1.034 1.491-2.699 2.855-4.35 1.985-.737-.39-.966-.638-1.638-1.758-.673-1.119-.785-1.437-.782-2.272.006-1.866 1.991-2.695 3.793-2.908 1.906-.226 3.17-.066 3.846 1.06z"
						  fill="currentColor"></path>
					<defs>
						<filter id="fade" x=".878" y=".337" width="19.958" height="19.298"
								filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
							<feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
							<feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape"></feBlend>
							<feGaussianBlur stdDeviation="3"
											result="effect1_foregroundBlur_116_127922"></feGaussianBlur>
						</filter>
					</defs>
				</svg>
				<svg className="garland-item" width="68" height="21" fill="none"
					 xmlns="http://www.w3.org/2000/svg">
					<path d="M67.5 7c-22.251 2.124-37.912 3.21-56 3.687" stroke="currentColor"></path>
					<g opacity=".8" filter="url(#fade)">
						<path className="garland-shadow"
							  d="M7.538 7.484c1.007-.845 2.253-.585 3.982.249 1.634.788 3.241 2.219 2.64 3.985-.27.79-.48 1.055-1.48 1.894-1 .84-1.297 1-2.121 1.128-1.844.285-2.974-1.546-3.467-3.292-.52-1.848-.56-3.12.446-3.964z"
							  fill="currentColor"></path>
					</g>
					<path className="garland-lamp"
						  d="M8.181 8.25c1.006-.845 2.253-.585 3.981.249 1.635.788 3.242 2.219 2.64 3.985-.268.79-.478 1.055-1.479 1.894-1 .84-1.297 1-2.122 1.128-1.843.285-2.973-1.546-3.466-3.292-.52-1.847-.56-3.12.446-3.964z"
						  fill="currentColor"></path>
					<defs>
						<filter id="fade" x=".732" y=".965" width="19.556" height="19.805"
								filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
							<feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
							<feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape"></feBlend>
							<feGaussianBlur stdDeviation="3"
											result="effect1_foregroundBlur_116_127927"></feGaussianBlur>
						</filter>
					</defs>
				</svg>
			</div>
		))}
	</div>
}

export const Theme = ({changeTheme}) => {

	const isDark = useSelector(({theme}) => theme.globalTheme === "dark");

	return <span className="ml-1">
		<div className="color-switch">
			<label className="switch">
				<input checked={isDark} type="checkbox" onChange={changeTheme}/>
				<span className="slider round"/>
			</label>
		</div>
	</span>
}

const Header = ({changeTheme, isDashboard, isAdmin}) => {

	const [search, showSearch] = useState(false);
	const isMobile = useMobile();
	const dispatch = useDispatch();
	const history = useHistory();
	const {pathname} = useLocation();
	const open = useSelector(({nav}) => nav.open);
	const isOpen = useSelector(({nav}) => nav.mobile);
	const isDark = useSelector(({theme}) => theme.globalTheme === "dark");
	const isAuth = useSelector(({auth}) => auth.isAuth);
	const isAuthLoading = useSelector(({auth}) => auth.loading);
	const isSettings = pathname.includes("/settings/");
	const isMain = pathname === "/";

	useEffect(() => {

		let isAdmin = window.location.origin.includes('admin');

		if (!isAuth) {
			dispatch(getSelfUser())
				.then(({status, data}) => {
					if (status === 200) {
						dispatch(getShops(data.user.username));
						if (isAdmin && +data.user.rank < 1) {
							history.push(`/home`);
						}
					}
				})
		}

	}, []);

	const onBoarding = () => {
		if (isSettings) {
			history.replace({hash: "#onboarding"});
		} else if (isMain) {
			history.replace({hash: "#onboarding"});
		} else {
			history.push({
				pathname: "/",
				hash: "#onboarding"
			});
		}
	}

	return (
		<>
			<Status/>

			<div className="header">

				{/*{isDashboard && <Garland />}*/}

				<div>

					<div className={`header-logo ${!open ? 'open' : ''}`}>

						<div className="sidebar-toggler" onClick={() => dispatch(openMobile(!isOpen))}>
							{!isOpen ? <Menu/> : <Close/>}
						</div>

						<Logo isAdmin={isAdmin} isDashboard={isDashboard}/>
					</div>

					<Logo mobile isAdmin={isAdmin} isDashboard={isDashboard}/>

					<div className={`header-nav ${!open ? 'open' : ''}`}>

						{isAdmin ? null : !isMobile ? <Searchbar/> :
							<MobileSearchbar open={search} close={() => showSearch(false)}/>}

						<div className="header-menu">
	
							{/* temporarily commented out, no Intercom integration */}

							{/* 
							{isAdmin ? null :
								<div id="intercom" className="header-intercom">
									<svg width="18" height="18" viewBox="0 0 18 18" fill="none"
										 xmlns="http://www.w3.org/2000/svg">
										<path
											d="M15.75 10.5L13.5 8.25H8.25C8.05109 8.25 7.86032 8.17098 7.71967 8.03033C7.57902 7.88968 7.5 7.69891 7.5 7.5V3C7.5 2.80109 7.57902 2.61032 7.71967 2.46967C7.86032 2.32902 8.05109 2.25 8.25 2.25H15C15.1989 2.25 15.3897 2.32902 15.5303 2.46967C15.671 2.61032 15.75 2.80109 15.75 3V10.5Z"
											stroke="#6A3CE2" strokeWidth="1.5" strokeLinecap="round"
											strokeLinejoin="round"/>
										<path
											d="M10.5 11.25V12.75C10.5 12.9489 10.421 13.1397 10.2803 13.2803C10.1397 13.421 9.94891 13.5 9.75 13.5H4.5L2.25 15.75V8.25C2.25 8.05109 2.32902 7.86032 2.46967 7.71967C2.61032 7.57902 2.80109 7.5 3 7.5H4.5"
											stroke="#6A3CE2" strokeWidth="1.5" strokeLinecap="round"
											strokeLinejoin="round"/>
									</svg>
									{isMobile ? null :
										<div className="header-intercom-text" style={{whiteSpace: "nowrap"}}>
											Get Support - 24/7
										</div>}
								</div>
							} 
							 */}

							<Theme changeTheme={changeTheme}/>

							<div className="search-icon" onClick={() => showSearch(true)}>
								<SearchIcon dark={isDark ? "#989BA0" : "#3F4A60"}/>
							</div>

							{/*{(isShop || isDoc) ? null : <Lang />}*/}

							<div className="onboarding-icon" style={{display: "none"}} onClick={onBoarding}>
								<Info dark={isDark ? "#989BA0" : "#3F4A60"}/>
							</div>

							<Notification/>

							{
								isAuth ?
									<User isAuthLoading={isAuthLoading} changeTheme={changeTheme}/> :
									isDashboard ?
										<UserPlaceholder/> :
										<Authentication/>
							}
						</div>

					</div>
				</div>
			</div>
		</>
	);
}


export default Header;
